import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getRepeatSentence = (params) => {
	var url = ApiRouters.REPEATSENTENCE;
	return api.get(url, { params });
};

export const getRepeatSentenceDetail = (id, params) => {
	var url = `${ApiRouters.REPEATSENTENCE}/${id}`;
	return api.get(url, { params });
};

export const createQuesRepeatSentence = (body) => {
	var url = ApiRouters.REPEATSENTENCE;
	return api.post(url, body);
};

export const updateRepeatSentenceDetail = (body) => {
	var url = `${ApiRouters.REPEATSENTENCE}/${body.id}`;
	return api.put(url, body);
};

export const deleteRepeatSentence = (id) => {
	var url = `${ApiRouters.REPEATSENTENCE}/${id}`;
	return api.delete(url);
};
